module.exports = __webpack_public_path__ + "img/abstract-shapes-2.c1742767.svg";